import { render, staticRenderFns } from "./contactoscl.vue?vue&type=template&id=482daa71&"
import script from "./contactoscl.vue?vue&type=script&lang=js&"
export * from "./contactoscl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports